import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Link, NewGrade as Grade } from "@bca/ui-library";

import KeyDecisionMakerContainer from "./KeyDecisionMakerContainer";
import { KeyDecisionMakerText } from "./mechanicalReport/styledElements/KeyDecisionMakerText";
import getBatteryGradeLetter from "../utilities/getBatteryGradeLetter";

const StyledLink = styled(Link)`
  ${css({
    fontSize: "body-small",
    textAlign: "center",
    paddingRight: [10, 0],
  })}
`;

const BatteryReport: React.FunctionComponent<{
  grade: number | null;
  onSlideoutOpen: () => void;
}> = ({ grade, onSlideoutOpen }) => {
  return (
    <KeyDecisionMakerContainer>
      <KeyDecisionMakerText>
        <Grade value={getBatteryGradeLetter(grade)} />
      </KeyDecisionMakerText>
      <StyledLink
        color="primary-light-blue"
        underline="always"
        onClick={onSlideoutOpen}
      >
        Battery Health
      </StyledLink>
    </KeyDecisionMakerContainer>
  );
};

export default BatteryReport;
